<template>
  <div>
    <headMenu />
    <router-view v-if="$route.path == '/dataReport'" />
    <div v-else>
      <div class="bavBreadBox">
        <bavBread />
      </div>

      <div class="adminRouterViewBox" :style="overF ? 'overflow: inherit;' : ''">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import bavBread from "@/views/admin/components/bavBread";
import headMenu from "@/views/admin/components/headMenu";

export default {
  components: {
    bavBread,
    headMenu,
  },
  data() {
    return {
      overF: false
    }
  },
  mounted() {
    console.log(99, this.$route.path);
    if (this.$route.path == '/information/theoryQuestionBank') {
      this.overF = true
    } else {
      this.overF = false
    }
    // el-table自适应
    window.onresize = () => {
      return (() => {
        this.$store.commit("setTableHeight");
      })();
    };
    this.$axios.get('/menu/user/perms').then(res => {
      let data = res.data.data;
      this.$store.commit("setUserRole", data);
    })
  },

};
</script>
<style lang="scss">
.adminRouterViewBox {
  min-width: 1000px;
  height: calc(100vh - 120px);
  padding: 10px 8%;
  overflow-x: hidden;
  overflow-y: auto;
}

.bavBreadBox {
  padding: 0px 8%;
}

@media screen and (max-width:1700px) {
  .adminRouterViewBox {
    padding: 10px 5%;
  }

  .bavBreadBox {
    padding: 0px 5%;
  }
}

@media screen and (max-width:1500px) {
  .adminRouterViewBox {
    padding: 10px;
  }

  .bavBreadBox {
    padding: 0px 10px;
  }
}
</style>
